import React, { useEffect, useState } from 'react';
export function StickyCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    // Show after 33 seconds
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 33 * 1000);
    return () => clearTimeout(timer);
  }, []);
  return <div className={`fixed bottom-0 left-0 w-full bg-white p-[10px_15px] shadow-[0_-5px_20px_rgba(0,0,0,0.15)] z-[9999] flex items-center justify-between transition-transform duration-300 border-t-[2px] border-[#7C3AED] md:hidden ${isVisible ? 'translate-y-0' : 'translate-y-full'}`} id="sticky-cta" data-id="element-260">
      <div className="text-left flex-1" data-id="element-261">
        <div className="text-[10px] uppercase text-[#6B7280] font-[700]" data-id="element-262">
          💜 El Apoyo Incondicional
        </div>
        <div className="flex items-baseline gap-[6px]" data-id="element-263">
          <div className="font-[800] text-[18px] text-[#1A1035]" data-id="element-264">$7.77</div>
          <div className="text-[11px] text-[#DC2626] font-[600] line-through" data-id="element-265">
            $19.99
          </div>
        </div>
      </div>
      <a href="https://oriammarketing.com/cart/45555442090182:1" className="bg-gradient-to-br from-[#7C3AED] to-[#6D28D9] text-white no-underline font-[900] px-[20px] py-[12px] rounded-[50px] text-[12px] uppercase shadow-md" data-id="element-266">
        DESCARGAR ➤
      </a>
    </div>;
}